import React, {FC, useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {RepartitionData} from '../core/_models'
import {DonutCard} from '@/components/cards/DonutCard'

type Props = {
  title: string
  dataProvider: () => Promise<Array<RepartitionData>>
  from: Date 
  to?: Date
  height: number
  translate: boolean
  showTotal?: boolean
}
const RepartitionChart : FC<Props> = ({dataProvider, title, height, translate, showTotal}) => {
  const intl = useIntl()
  const [data, setData] = useState<Array<RepartitionData>|undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const res = await dataProvider()
        setData(res||[])
      } catch (e: unknown) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [dataProvider])

  return (
    <DonutCard
      id="user-repartition"
      title={title}
      height={height}
      isLoading={isLoading}
      showTotal={showTotal}
      data={(data ||[]).map(d =>({
        label: translate === true
          ? intl.formatMessage({ id: `P2C.CUSTOMER.${d._id.toUpperCase()}`})
          : d._id,
        value: d.value
      }))}
    />
  )
}

export default RepartitionChart
